import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { __decorate } from "tslib";
import template from './index.vdt';
import { BaseSelect } from '../select/base';
import { useEqualWidth } from '../select/useEqualWidth';
import { _$ } from '../../i18n';
import { isNullOrUndefined, isStringOrNumber } from 'intact-shared';
import { useReceive } from '../../hooks/useReceive';
import { useValue } from './useValue';
import { bind } from '../utils';
var typeDefs = _extends({}, BaseSelect.typeDefs, {
  data: Array,
  filter: Function,
  uncorrelated: Boolean,
  load: Function,
  showLine: Boolean,
  defaultExpandAll: Boolean,
  checkbox: Boolean
});
var defaults = function defaults() {
  return _extends({}, BaseSelect.defaults(), {
    defaultExpandAll: true,
    showLine: true
  });
};
export var TreeSelect = /*#__PURE__*/function (_BaseSelect) {
  _inheritsLoose(TreeSelect, _BaseSelect);
  function TreeSelect() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseSelect.call.apply(_BaseSelect, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.value = useValue();
    return _this;
  }
  var _proto = TreeSelect.prototype;
  _proto.init = function init() {
    var _this2 = this;
    _BaseSelect.prototype.init.call(this);
    useEqualWidth();
    // if we get checkbox is true, set mutiple to true forcely
    useReceive(['checkbox', 'multiple'], function () {
      if (_this2.get('checkbox')) {
        _this2.set('multiple', true, {
          silent: true
        });
      }
    });
  };
  _proto.expandAll = function expandAll() {
    this.value.treeRef.value.expandAll();
  };
  _proto.getPlaceholder = function getPlaceholder() {
    var _this$get = this.get(),
      placeholder = _this$get.placeholder;
    return isNullOrUndefined(placeholder) ? _$('请选择') : placeholder;
  };
  _proto.getLabel = function getLabel() {
    var _this$get2 = this.get(),
      data = _this$get2.data,
      value = _this$get2.value,
      multiple = _this$get2.multiple;
    if (isNullOrUndefined(data) || isNullOrUndefined(value)) return;
    var label;
    var counts = 0;
    var loop = function loop(children) {
      return _findInstanceProperty(children).call(children, function (item) {
        if (!multiple) {
          if (item.key === value) {
            label = item.label;
            return true;
          }
        } else {
          var index = value.indexOf(item.key);
          if (index > -1) {
            if (!label) label = [];
            // keep the order
            label[index] = item.label;
            if (++counts === value.length) {
              return true;
            }
          }
        }
        if (item.children) {
          return loop(item.children);
        }
        return false;
      });
    };
    loop(data);
    return label;
  };
  _proto.filter = function filter(data) {
    var _context2, _context3;
    var keywords = this.input.keywords.value;
    if (!keywords) return true;
    var _this$get3 = this.get(),
      filter = _filterInstanceProperty(_this$get3);
    if (filter) return filter(keywords, data);
    keywords = keywords.toLowerCase();
    return isStringOrNumber(data.label) && _includesInstanceProperty(_context2 = String(data.label).toLowerCase()).call(_context2, keywords) || _includesInstanceProperty(_context3 = String(data.key).toLowerCase()).call(_context3, keywords);
  };
  return TreeSelect;
}(BaseSelect);
TreeSelect.template = template;
TreeSelect.typeDefs = typeDefs;
TreeSelect.defaults = defaults;
__decorate([bind], TreeSelect.prototype, "filter", null);